import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { Environment } from '../../../shared/environment';

interface IFabricaImpressao {
  idfabrica: string;
  nome: string;
  logo: string;
  itens: IItensImpressao[];
}

interface IItensImpressao {
  descricao: string;
  quantidade: number;
  un: string;
  preco: number;
  total: number;
  ean: string;
  nome: string;
}

interface IImpressao {
  nome: string;
  cpf: string;
  rg: string;
  cep: string;
  endereco: string;
  bairro: string;
  municipio: string;
  uf: string;
  telefone: string;
  descricao: string;
  emissao: Date;
  numero: number;
  valor: number;
  fabricas: IFabricaImpressao[];
}

async function PDFPedidos(dados: IImpressao) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => reject(`Erro ao carregar imagem: ${url}`);
      img.src = url;
    });
  }

  const imageUrl = process.env.REACT_APP_URL_IMAGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);
  if (!imageData.startsWith('data:image')) {
    throw new Error('Imagem inválida (base64 mal gerado).');
  }

  let qtd = 0;
  let totalGeral = 0;

  const documentDefinition: any = {
    pageSize: { width: 226.77, height: 'auto' }, // 80mm
    pageMargins: [5, 10, 5, 10],
    content: [
      {
        style: 'tableExample',
        table: {
          widths: ['auto', '*'],
          body: [
            [
              { image: imageData, width: 60, alignment: 'left', border: [false, false, false, false] },
              {
                text: 'PRONTA ENTREGA',
                fontSize: 12,
                alignment: 'left',
                margin: [5, 2, 0, 0],
                border: [false, false, false, false],
              },
            ],
            [
              {
                colSpan: 2,
                border: [false, false, false, false],
                margin: [10, 5, 0, 5],
                table: {
                  widths: ['*', '*'],
                  body: [
                    [
                      {
                        text: '(71)98179-1818',
                        fontSize: 10,
                        alignment: 'center',
                        border: [false, false, false, false],
                      },
                      {
                        text: `${dados.descricao} Nº ${dados.numero}`,
                        fontSize: 10,
                        alignment: 'center',
                        border: [false, false, false, false],
                      },
                    ],
                  ],
                },
                layout: 'noBorders',
              },
              {},
            ],
          ],
        },
      },
      {
        margin: [0, 5, 0, 5],
        table: {
          widths: ['*'],
          body: [
            [{ text: `Cliente: ${dados.nome}`, fontSize: 9 }],
            [{ text: `CPF/CNPJ: ${dados.cpf}   Telefone: ${dados.telefone}`, fontSize: 9 }],
            [{ text: `Emissão: ${moment(dados.emissao).format('DD/MM/YYYY')}`, fontSize: 9 }],
            [{ text: `Endereço: ${dados.endereco}, ${dados.bairro}`, fontSize: 9 }],
            [{ text: `Município: ${dados.municipio} - ${dados.uf}`, fontSize: 9 }],
            [{ text: `CEP: ${dados.cep}`, fontSize: 9 }],
          ],
        },
      },
      ...(await Promise.all(
        dados.fabricas.flatMap(async (e) => {
          const { itens } = e;
          const imageData1 = await getBase64ImageFromUrl(Environment.URL_IMGFABRICA + (e.logo || ''));
          const TProdutos = itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);
          const Ttotal = itens.reduce((acc, item) => acc + (item.total || 0), 0);
          qtd += TProdutos;
          totalGeral += Ttotal;

          const rows = itens.map((row) => [
            {
              text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(row.quantidade),
              alignment: 'right',
              fontSize: 8,
            },
            {
              text: row.descricao,
              alignment: 'left',
              fontSize: 8,
            },
            {
              text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(row.preco),
              alignment: 'right',
              fontSize: 8,
            },
            {
              text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2}).format(row.total),
              alignment: 'right',
              fontSize: 8,
            },
          ]);

          return [
            {
              columns: [
                {
                  image: imageData1,
                  width: 40,
                  alignment: 'left',
                },
                {
                  text: e.nome,
                  fontSize: 10,
                  bold: true,
                  alignment: 'left',
                  margin: [10, 0, 5, 0],
                },
              ],
              margin: [0, 5, 0, 5],
            },
            {
              table: {
                widths: [25, '*', 30, 35],
                body: [
                  [
                    { text: 'Qtd.', alignment: 'right', fillColor: '#eeeeee', fontSize: 8 },
                    { text: 'Descrição', alignment: 'left', fillColor: '#eeeeee', fontSize: 8 },
                    { text: 'Preço', alignment: 'right', fillColor: '#eeeeee', fontSize: 8 },
                    { text: 'Total', alignment: 'right', fillColor: '#eeeeee', fontSize: 8 },
                  ],
                  ...rows,
                ],
              },
            },
            {
              table: {
                widths: ['*', 50],
                body: [
                  [
                    {
                      text: 'Total de Itens: ' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2,maximumFractionDigits: 2, }).format(TProdutos),
                      fontSize: 8,
                      border: [false, false, false, false],
                    },
                    {
                      text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(Ttotal),
                      fontSize: 8,
                      alignment: 'center',
                      margin: [false, false, 10, false],
                      border: [false, false, false, false],
                    },
                  ],
                ],
              },
            },
          ];
        })
      )),
      {
        text: `Total Geral de Itens: ${new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(qtd)}`,
        fontSize: 9,
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 33.385,
            y1: 0,
            x2: 193.385,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 30, 0, 0],
      },
      {
        text: 'CLIENTE',
        alignment: 'center',
        margin: [0, 2, 0, 0],
        fontSize: 9,
        bold: true,
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 33.385,
            y1: 0,
            x2: 193.385,
            y2: 0,
            lineWidth: 1,
          },
        ],
        margin: [0, 30, 0, 0],
      },
      {
        text: 'VENDEDOR',
        alignment: 'center',
        margin: [0, 2, 0, 20],
        fontSize: 9,
        bold: true,
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}

export default PDFPedidos;
